<template>
  <Preloader ref="preloader" v-if="loading" />
  <div v-else class="md-offset">
    <div class="md-layout  mt-fixed">
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>assignment</md-icon>
            </div>
            <h4 class="title">
              Podsumowanie
              <a
                @click.prevent="showInfoModal(modals.summary)"
                href="/"
                class="info-icon"
              >
                <md-icon class="text-info">info_outline</md-icon>
                <md-tooltip md-direction="bottom">{{
                  modals.summary.tooltip
                }}</md-tooltip>
              </a>
            </h4>
          </md-card-header>
          <md-card-content>
            <SummaryData />
          </md-card-content>
        </md-card>
      </div>
      <div class="md-layout-item">
        <md-card>
          <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
              <md-icon>receipt</md-icon>
            </div>
            <h4 class="title">
              Zamów swój raport
              <a
                @click.prevent="showInfoModal(modals.order)"
                href="/"
                class="info-icon"
              >
                <md-icon class="text-info">info_outline</md-icon>
                <md-tooltip md-direction="bottom">{{
                  modals.order.tooltip
                }}</md-tooltip>
              </a>
            </h4>
          </md-card-header>
          <md-card-content class="test">
            <OrderForm />
          </md-card-content>
        </md-card>
      </div>
    </div>
    <ConfiguratorModal ref="modalInfo" />
  </div>
</template>

<script>
import OrderForm from '../../components/OrderForm'
import SummaryData from '../../components/SummaryData'
import ConfiguratorModal from '../../components/ConfiguratorModal'
export default {
  name: 'Summary',
  components: {
    OrderForm,
    SummaryData,
    ConfiguratorModal,
  },
  data() {
    return {
      loading: true,
      modals: {
        summary: {
          tooltip:
            'Podsumowanie Twoich potrzeb i wstępna wycena planu ubezpieczeniowego',
          title: 'Podsumowanie',
          text: [
            'Oto podsumowanie Twoich potrzeb i oczekiwań oznaczonych w konfiguratorze. Widoczna wstępna wycena Twojego planu ubezpieczeniowego oparta jest na standardowej taryfie składek obowiązującej w zakładzie ubezpieczeń dla osoby w Twoim wieku i nie może być traktowana jako oferta w rozumieniu kodeksu cywlinego. Decyzję o zawarciu umowy bądź umów ubezpieczenia i ich warunkach podejmie zakład ubezpieczeń po analizie Twojego wniosku i oświadczeń dotyczących w szczególności wykonywanego zawodu i stanu zdrowia.',
          ],
        },
        order: {
          tooltip:
            'Zamów raport ze szczegółami swojego planu ubezpieczeniowego',
          title: 'Zamówienie',
          text: [
            'Jeśli chcesz poznać szczegóły planu ubezpieczeniowego wypełnij poniższy formularz. Na adres mailowy wyślemy Ci szczegółowy raport z nazwami i opisem produktów oraz ich rekomendowanymi parametrami dopasowanymi do Twoich potrzeb i oczekiwań. Do raportu dołączymy ogólne warunki ubezpieczenia oraz karty produktów - oficjalną dokumentację, którą musimy Ci dostarczyć w świetle przepisów prawa. ',
            'W ciągu 48 godzin skontaktujemy się z Tobą żeby przybliżyć Ci procedurę uruchomienia Twojego planu ubezpieczeniowego, wyjaśnimy również wszystkie Twoje wątpliwości związane z ofertą Ubezpieczyciela. Jeśli zdecydujesz się na zawarcie umowu ubezpieczenia zajmiemy się wszystkimi formalnościami - obecnie możliwymi do załatwienia przez internet.',
          ],
        },
      },
    }
  },
  created() {
    this.loading = false
    window.scrollBy()
  },
  methods: {
    showInfoModal(data) {
      this.$refs.modalInfo.open(data)
    },
  },
}
</script>

<style scoped lang="scss">
h4.title {
  font-size: 21px !important;
  font-weight: 700 !important;
  .info-icon i {
    font-weight: 400;
    font-size: 27px !important;
    width: 30px;
  }
}

.mt-fixed {
  margin-top: 120px;
  @media screen and (max-width: 576px) {
    margin-top: 80px;
  }
  .md-layout-item {
    &:first-child {
      padding-left: 0;
    }
    &:last-child {
      padding-right: 0;
    }
    @media screen and (max-width: 768px) {
      padding: 0;
    }
  }
}
.wrapp {
  width: 1110px;
  margin: 0 auto;
}
</style>
